import {View} from '~/shared/src/model/User';

import {BATCH_ACTIONS, USER_SET_VIEWS_FOR_MODULE} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import saveCfgItem from '~/frontend/src/actions/user/saveCfgItem';
import loadCfgItem from '~/frontend/src/actions/user/loadCfgItem';
import {setMessage, MsgParams} from '~/frontend/src/actions/intercom';


export type SetViewsForModuleAction = {
    type : typeof USER_SET_VIEWS_FOR_MODULE;
    subType : typeof BATCH_ACTIONS;
    actions : any[];
}

/**
 * @memberOf! Actions
 *
 * @param {string|string[]} module
 * @param {View[]} views
 * @param {MsgParams | undefined} [successMsgParams=undefined]
 * @param {MsgParams | undefined} [errorMsgParams=undefined]
 *
 * @return {}
 */
const setViewsForModule = ( module : string | string[], views : View[], successMsgParams : MsgParams | undefined = undefined, errorMsgParams : MsgParams | undefined = undefined ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) => {
    const user               = getState().session.user,
          actions : object[] = [
              {
                  type: USER_SET_VIEWS_FOR_MODULE,
                  module,
                  views,
                  successMsgParams,
                  errorMsgParams
              }
          ];

    if ( user ) {
        user.setViewsForModule( module, views );

        if ( await dispatch( saveCfgItem( 'noMask' ) ) ) {
            const result = await dispatch( loadCfgItem( 'noMask' ) );

            if ( result ) {
                if ( successMsgParams ) {
                    actions.push( setMessage( ...successMsgParams ) );
                }
            }
            else if ( errorMsgParams ) {
                actions.push( setMessage( ...errorMsgParams ) );
            }

            dispatch( {
                type   : USER_SET_VIEWS_FOR_MODULE,
                subType: BATCH_ACTIONS,
                actions
            } );
        }
    }
}

export type SetViewsForModule = typeof setViewsForModule;

export default setViewsForModule;
